import type { HandleUploadFilesFuncType } from '@core/core/modules'
import type {
  ContextMenuItemType,
  ObjectTreeNode,
  SubMenuActionsType,
  SubMenuExportType,
  SubMenuProcessesType,
  SubMenuUploadFileType,
} from '@core/core/types'
import {
  isContextMenuItem,
  isSubMenuActions,
  isSubMenuExport,
  isSubMenuNewObject,
  isSubMenuProcesses,
  isSubMenuUploadFile,
} from '@core/core/types'

import type { ContextSubMenuItemType, HandleDownloadFilesFuncType, ToBinFuncType } from '../types'

export const getActionFromItem = (
  itemType: ContextSubMenuItemType,
  toggleMapBuildingModal: VoidFunction,
  showGeoDbImportSidebar: VoidFunction,
  handleUploadFiles: HandleUploadFilesFuncType,
  handleConvertMarkerToPoints: VoidFunction,
  handleExportFiles: HandleDownloadFilesFuncType,
  handleToBin: ToBinFuncType,
  handleOpenVSPInTable: VoidFunction,
  handlePublishElements: VoidFunction,
  handleCopy: VoidFunction,
  objectTreeNode?: ObjectTreeNode,
) => {
  // Base Context Menu
  if (isContextMenuItem(itemType)) {
    const contextMenuItemMapper: Partial<Record<ContextMenuItemType, VoidFunction>> = {
      ImportFromDB: showGeoDbImportSidebar,
      ToBin: () => {
        if (objectTreeNode) {
          handleToBin(objectTreeNode.uid, objectTreeNode.name)
        }
      },
      Export: () => {
        handleExportFiles(objectTreeNode)
      },
      OpenInTable: handleOpenVSPInTable,
      Publish: handlePublishElements,
      Copy: handleCopy,
    }

    return contextMenuItemMapper[itemType]?.()
  }

  // Import from file (Upload)
  if (isSubMenuUploadFile(itemType)) {
    const subMenuUploadFileMapper: Partial<
      Record<SubMenuUploadFileType, VoidFunction | HandleUploadFilesFuncType>
    > = {
      Survey2D: type => {
        handleUploadFiles(type, objectTreeNode)
      },
      Survey3D: handleUploadFiles,
      Horizon: handleUploadFiles,
      Fault: handleUploadFiles,
      Polygons: handleUploadFiles,
      Maps: handleUploadFiles,
      Attribute: type => {
        handleUploadFiles(type, objectTreeNode)
      },
      VSP: type => {
        handleUploadFiles(type, objectTreeNode)
      },
    }

    return subMenuUploadFileMapper[itemType]?.(itemType)
  }

  // New Object
  if (isSubMenuNewObject(itemType)) {
    console.warn('Not Implemented: SubMenuNewObject')
    return
  }

  // Processes
  if (isSubMenuProcesses(itemType)) {
    const subMenuProcessesMapper: Partial<Record<SubMenuProcessesType, VoidFunction>> = {
      Mapping: toggleMapBuildingModal,
    }

    return subMenuProcessesMapper[itemType]?.()
  }

  // Actions
  if (isSubMenuActions(itemType)) {
    const subMenuActionsMapper: Partial<Record<SubMenuActionsType, VoidFunction>> = {
      ConvertToDots: handleConvertMarkerToPoints,
    }

    return subMenuActionsMapper[itemType]?.()
  }

  // Export to file (Download)
  if (isSubMenuExport(itemType)) {
    const subMenuExportMapper: Partial<
      Record<SubMenuExportType, VoidFunction | HandleDownloadFilesFuncType>
    > = {
      Charisma: () => {
        handleExportFiles(objectTreeNode)
      },
      Export_IrapGrid: () => {
        handleExportFiles(objectTreeNode)
      },
      ExportIrapPolygon: () => {
        handleExportFiles(objectTreeNode)
      },
    }

    return subMenuExportMapper[itemType]?.()
  }
}
